export default __webpack_public_path__ + "static/media/avi.a5285e20.svg";